export const sectionHeading = {
  fontFamily: "'Clash Display', sans-serif",
  fontSize: 'clamp(24px, 3.5vw, 32px)',
  fontWeight: '600',
  marginBottom: '24px',
  color: '#C4B5FD',
};

export const bodyText = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  fontFamily: "'Inter', sans-serif",
  fontSize: '22px',
  color: '#E8E8E3',
  lineHeight: '1.6',
};

export const calloutHeading = {
  fontFamily: "'Clash Display', sans-serif",
  fontSize: '22px',
  fontWeight: '600',
  marginBottom: '12px',
  color: '#C4B5FD',
};

export const subheading = {
  fontFamily: "'Clash Display', sans-serif",
  fontSize: '22px',
  fontWeight: '600',
  marginBottom: '16px',
  color: '#E8E8E3',
};

export const phoneCol = {
  flex: '1 1 50%',
  minWidth: '300px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0 16px',
};

export const phoneTitle = {
  fontFamily: "'Clash Display', sans-serif",
  fontSize: '22px',
  fontWeight: '600',
  marginBottom: '12px',
  color: '#E8E8E3',
  textAlign: 'center',
};

export const phoneMockup = {
  width: '100%',
  maxWidth: '320px',
  borderRadius: '40px',
  boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
  marginBottom: '16px',
};

export const phoneCaption = {
  fontFamily: "'Inter', sans-serif",
  fontSize: '22px',
  color: '#E8E8E3',
  lineHeight: '1.6',
  maxWidth: '420px',
};

export const phonePairRow = {
  display: 'flex',
  gap: '0px',
  flexWrap: 'wrap',
};

export const h4Accent = {
  fontFamily: "'Clash Display', sans-serif",
  fontSize: '20px',
  fontWeight: '600',
  marginBottom: '16px',
  color: '#C4B5FD',
};

export const beforeAfterHeading = {
  fontFamily: "'Clash Display', sans-serif",
  fontSize: 'clamp(20px, 3vw, 24px)',
  fontWeight: '600',
  marginBottom: '16px',
  color: '#E8E8E3',
};

export const italicIntro = {
  fontFamily: "'Inter', sans-serif",
  fontSize: '22px',
  color: '#E8E8E3',
  lineHeight: '1.6',
  fontStyle: 'italic',
  marginBottom: '32px',
};

export const orderedList = {
  fontFamily: "'Inter', sans-serif",
  fontSize: '22px',
  color: '#E8E8E3',
  lineHeight: '1.6',
  paddingLeft: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  marginBottom: '32px',
  listStyleType: 'decimal',
  listStylePosition: 'outside',
};

export const screenshotCenter = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '40px',
};

export const screenshotImg = {
  width: '100%',
  maxWidth: '700px',
  borderRadius: '24px',
  boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
};

export const calloutBodyText = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  fontFamily: "'Inter', sans-serif",
  fontSize: '22px',
  color: '#E8E8E3',
  lineHeight: '1.6',
};
